const de = {
    adApproval: 'Feedbackeinwilligung',
    adApprovalConsent: 'Zustimmen',
    adApprovalNoThanks: 'Nein, Danke',
    appointmentBookingClosed: 'Die Terminbuchung ist aktuell geschlossen.',
    appointmentNotAvailableAnymore: 'Termin nicht mehr verfügbar, bitte wählen Sie einen anderen Termin.',
    appointmentSelection: 'Termin auswählen',
    availableAppointments: 'sind folgende Termine noch frei:',
    back: 'Zurück',
    bookingAlreadyCancelled: 'Buchung bereits storniert',
    bookingAlreadyCancelledText: 'Die von Ihnen aufgerufene Buchung wurde bereits storniert.',
    bookingForWaitingListInfo: 'Sie werden auf der Warteliste eingetragen.',
    bookingSuccessful: 'Buchung erfolgreich',
    bookingSuccessfullyCancelled: 'Stornierung erfolgreich',
    bookingSuccessfullyCancelledText: ({ date }) => (
        <>
            Ihr Termin am {date} wurde erfolgreich storniert. Sie erhalten in Kürze eine Bestätigungsmail.
        </>
    ),
    bookingTextCancelInfo: 'Falls Sie den gebuchten Termin nicht wahrnehmen können, stornieren Sie Ihren Termin bitte'
        + ' über den Link in den E-Mails zur Terminbestätigung oder Terminerinnerung.',
    bookingTextFinisher: 'Wir freuen uns auf Sie!',
    bookingTextIcsLinkText: 'Jetzt in Ihren Kalender eintragen (Download ICS-Datei)',
    bookingTextMailInfoAppointment: 'wir haben Ihnen eine E-Mail zur Terminbestätigung an Ihre angegebene'
        + ' E-Mail-Adresse gesendet:',
    bookingTextReminderMailInfo: 'Um Sie an Ihren gebuchten Termin zu erinnern, senden wir Ihnen 24 Stunden vor dem'
        + ' Termin eine weitere E-Mail zu.',
    bookingTextSuccessInfoAppointment: 'ihr Termin wurde erfolgreich gebucht.',
    bookingTextSuccessInfoWaitingList: 'wir haben Sie auf der Warteliste eingetragen und melden uns bei Ihnen, sobald'
        + ' weitere Termine verfügbar sind.',
    cancelBookingNow: 'Ja, Termin jetzt stornieren',
    cancelBookingTitle: ({ date }) => <>Möchten Sie Ihren Termin am {date} stornieren?</>,
    cancellingBooking: 'Storniere...',
    campaignLinkTitle: 'Jetzt anmelden',
    contact: 'Kontakt',
    continue: 'Weiter',
    currentlyActive: 'Zurzeit aktiv',
    dataConsent: 'Datenschutzeinwilligung',
    documentTitleBookAppointment: 'Termin buchen | SBK Terminverwaltung',
    documentTitleCampaignCollection: 'SBK Gesundheitsaktionen',
    documentTitleCampaignRegister: 'SBK Registrierung',
    documentTitleCancelBooking: 'Termin stornieren | SBK Terminverwaltung',
    during: 'Im',
    findNewAppointment: 'Neuen Termin suchen',
    finishAppointmentBooking: 'Terminbuchung abschließen',
    finishAppointmentBookingInfoText: 'Bitte prüfen Sie Ihre Angaben zur Terminbuchung und klicken Sie danach auf'
        + ' Buchung abschließen.',
    finishBooking: 'Buchung abschließen',
    finishRegistration: 'Registrierung abschließen',
    finishRegistrationInfoText: 'Bitte prüfen Sie nochmals Ihre Angaben auf Korrektheit und bestätigen Sie die'
        + ' Registrierung.',
    finishWaitListBooking: 'Buchung Warteliste abschließen',
    finishWaitListBookingInfoText: 'Bitte prüfen Sie Ihre Angaben für die Warteliste und klicken Sie danach auf'
        + ' Buchung abschließen.',
    footerAccessibility: 'Barrierefreiheit & Leichte Sprache',
    footerLegalInformation: 'Impressum',
    footerPrivacy: 'Datenschutz',
    freeAppointment: 'Freier Termin',
    freeAppointmentsCount: ({ count }) => (count === 1 ? '1 freier Termin' : `${count} freie Termine`),
    greetings: 'Freundliche Grüße',
    incorrectCancellationCode: 'Fehlerhafter Stornierungscode',
    incorrectCancellationCodeText: 'Der Stornierungscode ist fehlerhaft. Bitte rufen Sie die Seite noch einmal über'
        + ' den Link in der Mail auf oder kontaktieren sie einen SBK-Mitarbeiter.',
    loading: 'Lade...',
    loadingTakesLongInfo: 'Das Laden dauert ungewöhnlich lange.',
    loadingTakesLongPleaseWait: 'Bitte warten Sie noch einen Moment.',
    maxAttendeesReached: 'Hinweis: Die Registrierung ist geschlossen, da die maximale Anzahl von Teilnehmern erreicht'
        + ' wurde.',
    no: 'Nein',
    noAppointmentsAvailableAnymore: 'Keine Termine mehr verfügbar.',
    noSuitableAppointmentLinkText: () => <>Setzen Sie sich auf die <u>Warteliste</u>.</>,
    noSuitableAppointmentQuestion: 'Kein passender Termin dabei?',
    note: 'Hinweis',
    pageNotFound: 'Seite nicht gefunden (404)',
    pageNotFoundText: 'Hoppla! Die von Ihnen aufgerufene Seite wurde leider nicht gefunden. Gerne löse ich Ihr'
        + ' Anliegen persönlich - bitte rufen Sie mich an oder schreiben Sie mir eine Nachricht. Ich freue mich über'
        + ' Ihr Feedback zur nicht gefundenen Seite, dann kann ich mich auch darum kümmern.',
    personalData: 'Angaben einfügen',
    personalDataInfoTextAppointment: 'Bitte füllen Sie das Formular mit Ihren Angaben aus und klicken Sie danach auf'
        + ' Weiter.',
    personalDataInfoTextWaitingList: 'Um sich auf die Warteliste setzen zu lassen, füllen Sie bitte das Formular mit'
        + ' Ihren Angaben aus und klicken Sie danach auf Weiter.',
    pleaseChooseAnAppointment: 'Bitte wählen Sie einen grün markierten Termin im Kalender aus, klicken Sie auf den'
        + ' gewünschten freien Termin und danach auf Weiter.',
    progressBar: 'Fortschrittsanzeige',
    registerNow: 'Jetzt anmelden',
    registrationClosed: 'Hinweis: Die Registrierung ist aktuell geschlossen.',
    registrationContactInfo: 'wir werden uns zeitnah mit Ihnen in Verbindung setzen.',
    requiredFieldsInfo: 'Die mit einem Sternchen (*) gekennzeichneten Felder sind Pflichtfelder.',
    sbkApiCommunicationError: 'Fehler bei der Kommunikation mit der SBK-API',
    sbkApiCommunicationErrorText: 'Wir haben momentan Probleme die gewünschten Daten abzurufen, bitte versuchen Sie es'
        + ' später noch einmal.',
    sbkLogoAltText: 'Logo der SBK',
    selectedAppointment: 'Ausgewählter Termin',
    step: 'Schritt',
    textCheckMailInfo: 'Sollten Sie innerhalb der nächsten 10 Minuten keine E-Mail von uns erhalten, prüfen Sie bitte'
        + ' Ihren Spam-Ordner.',
    to: 'bis',
    unknownError: 'Unbekannter Fehler',
    unknownErrorText: 'Es ist ein unbekannter Fehler aufgetreten. Bitte versuchen Sie es später noch einmal oder'
        + ' kontaktieren Sie einen SBK-Mitarbeiter.',
    unknownErrorTryImmediately: 'Unbekannter Fehler. Bitte versuchen Sie es erneut.',
    yes: 'Ja',
    yourAppointmentBooking: 'Ihre Terminbuchung',
    yourAppointmentBookingWasSuccessful: 'Ihr Termin wurde für Sie gebucht.',
    yourData: 'Ihre Daten',
    yourRegistrationWasSuccessful: 'Ihre Anmeldung war erfolgreich.',
    yourWaitListBooking: 'Ihre Buchung',
    yourWaitListBookingWasSuccessful: 'Sie sind auf der Warteliste eingetragen.',
};

const en = {
    adApproval: 'Advertising consent',
    adApprovalConsent: 'Consent',
    adApprovalNoThanks: 'No, thanks',
    appointmentBookingClosed: 'The appointment booking is currently closed.',
    appointmentNotAvailableAnymore: 'Time slot no longer available, please choose another date.',
    appointmentSelection: 'Appointment selection',
    availableAppointments: 'the following appointments are still available:',
    back: 'Back',
    bookingAlreadyCancelled: 'Booking already cancelled',
    bookingAlreadyCancelledText: 'The booking you requested has already been cancelled.',
    bookingForWaitingListInfo: 'You will be added to the waiting list.',
    bookingSuccessful: 'Booking successful',
    bookingSuccessfullyCancelled: 'Cancellation successful',
    bookingSuccessfullyCancelledText: ({ date }) => (
        <>
            Your appointment on {date} was successfully cancelled. You will receive a confirmation email shortly.
        </>
    ),
    bookingTextCancelInfo: 'If you are unable to attend the booked appointment, please cancel your appointment using'
        + ' the link in the appointment confirmation or appointment reminder emails.',
    bookingTextFinisher: 'We are looking forward to you!',
    bookingTextIcsLinkText: 'Add to your calendar now (Download ICS file)',
    bookingTextMailInfoAppointment: 'we have sent you an email confirming your appointment to the email address you'
        + ' provided:',
    bookingTextReminderMailInfo: 'To remind you of your booked appointment, we will send you another email 24 hours'
        + ' before the appointment.',
    bookingTextSuccessInfoAppointment: 'your appointment was successfully booked.',
    bookingTextSuccessInfoWaitingList: 'we have added you to the waiting list and will contact you as soon as more'
        + ' dates are available.',
    cancelBookingNow: 'Yes, cancel appointment now',
    cancelBookingTitle: ({ date }) => <>Would you like to cancel your appointment on {date}?</>,
    cancellingBooking: 'Cancelling...',
    campaignLinkTitle: 'Register now',
    contact: 'Contact',
    continue: 'Continue',
    currentlyActive: 'currently active',
    dataConsent: 'Privacy consent',
    documentTitleBookAppointment: 'Book appointment | SBK appointment management',
    documentTitleCampaignCollection: 'SBK Health Campaigns',
    documentTitleCampaignRegister: 'SBK Registration',
    documentTitleCancelBooking: 'Cancel appointment | SBK appointment management',
    during: 'In',
    findNewAppointment: 'Find new appointment',
    finishAppointmentBooking: 'Finish appointment booking',
    finishAppointmentBookingInfoText: 'Please check your appointment booking details and click Finish booking.',
    finishBooking: 'Finish booking',
    finishRegistration: 'Finish registration',
    finishRegistrationInfoText: 'Please check your information again for correctness and confirm the registration.',
    finishWaitListBooking: 'Complete waiting list booking',
    finishWaitListBookingInfoText: 'Please check your details for the waiting list and click Complete Booking.',
    footerAccessibility: 'Accessibility & simplified language',
    footerLegalInformation: 'Legal information',
    footerPrivacy: 'Privacy',
    freeAppointment: 'Free appointment',
    freeAppointmentsCount: ({ count }) => (count === 1 ? '1 available appointment' : `${count} available appointments`),
    greetings: 'Kind regards',
    incorrectCancellationCode: 'Incorrect cancellation code',
    incorrectCancellationCodeText: 'The cancellation code is incorrect. Please access the page again via the link in'
        + ' the mail or contact an SBK representative.',
    loading: 'Loading...',
    loadingTakesLongInfo: 'Loading takes an unusually long time.',
    loadingTakesLongPleaseWait: 'Please wait a few more seconds.',
    maxAttendeesReached: 'Please note: The registration is closed because the maximum number of attendees has been'
        + ' reached.',
    no: 'No',
    noAppointmentsAvailableAnymore: 'No appointments available anymore.',
    noSuitableAppointmentLinkText: () => <>Join the <u>waiting list</u>.</>,
    noSuitableAppointmentQuestion: 'No suitable appointment available?',
    note: 'Note',
    pageNotFound: 'Page not found (404)',
    pageNotFoundText: 'Oops! Sorry, the page you requested was not found. I will be happy to solve your problem'
        + ' personally - please call me or send me a message. I appreciate your feedback about the not found page,'
        + ' then I can take care of it as well.',
    personalData: 'Insert details',
    personalDataInfoTextAppointment: 'Please fill in the form with your details and click continue.',
    personalDataInfoTextWaitingList: 'To be placed on the waiting list, please fill in the form with your details and'
        + ' click Next.',
    pleaseChooseAnAppointment: 'Please select a green marked date in the calendar, click on the desired free date and'
        + ' then on Continue.',
    progressBar: 'Progress Bar',
    registerNow: 'Register now',
    registrationClosed: 'Please note: The registration is currently closed.',
    registrationContactInfo: 'we will contact you soon.',
    requiredFieldsInfo: 'The fields marked with an asterisk (*) are mandatory.',
    sbkLogoAltText: 'Logo of the SBK',
    sbkApiCommunicationError: 'Error while communicating with the SBK API',
    sbkApiCommunicationErrorText: 'We are currently having problems retrieving the requested data, please try again'
        + ' later.',
    selectedAppointment: 'Selected appointment',
    step: 'Step',
    textCheckMailInfo: 'If you do not receive an email from us within the next 10 minutes, please check your spam'
        + ' folder.',
    to: 'to',
    unknownError: 'Unknown Error',
    unknownErrorText: 'An unknown error has occurred. Please try again later or contact an SBK representative.',
    unknownErrorTryImmediately: 'Unknown error. Please try again.',
    yes: 'Yes',
    yourAppointmentBooking: 'Your appointment booking',
    yourAppointmentBookingWasSuccessful: 'Your appointment has been booked for you.',
    yourData: 'Your data',
    yourRegistrationWasSuccessful: 'Your registration was successful.',
    yourWaitListBooking: 'Your booking',
    yourWaitListBookingWasSuccessful: 'You are registered on the waiting list.',
};

const translations = {
    de,
    en,
};

export default translations;
